import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ContentHeaderKey } from "src/app/constants/content-header";

@Component({
    selector: 'mwp-member-my-benefits',
    templateUrl: './my-benefits.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberMyBenefitsComponent implements OnInit {
    public apiUrl = ContentHeaderKey.EnrollmentCurrentAndPendingBenefits;

    constructor(
    ) {
    }

    ngOnInit(): void {
    }
}